import pt from '../locales/pt.json';

const getLocaleNamespaces = () => Object.keys(pt);

export default getLocaleNamespaces;
